import { render } from "./ListComponent.vue?vue&type=template&id=dc6c54ca&scoped=true"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"

import "./ListComponent.vue?vue&type=style&index=0&id=dc6c54ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6c54ca"]])

export default __exports__